{
  "list": {
    "title": "Filtre",
    "create": "Opprett filter",
    "import": "Importer filter",
    "loadError": "En feil oppstod ved innlasting av filtre.",
    "statusAll": "Alle",
    "statusEnabled": "Aktivert",
    "statusDisabled": "Deaktivert",
    "noStatusFilters": "Ingen {{status}} filtre",
    "noFilters": "Ingen filtre her..",
    "addNew": "Legg til ny",
    "copied": "Filter kopiert til utklippstavlen!",
    "copyFailed": "Klarte ikke å kopiere JSON til utklippstavlen.",
    "fetchFailed": "Klarte ikke å hente filterdata.",
    "deleted": "Filter {{name}} ble slettet",
    "duplicated": "Filter {{name}} ble duplisert",
    "updated": "{{name}} ble vellykket oppdatert",
    "removeTitle": "Fjern filter: {{name}}",
    "removeText": "Er du sikker på at du vil fjerne dette filteret? Denne handlingen kan ikke angres.",
    "edit": "Rediger",
    "exportJson": "Eksporter JSON",
    "exportJsonDiscord": "Eksporter JSON til Discord",
    "toggle": "Veksle",
    "duplicate": "Dupliser",
    "delete": "Slett",
    "toggleSuccess": "{{name}} ble vellykket {{state}}",
    "enabledState": "aktivert",
    "disabledState": "deaktivert",
    "autoUpdatedTitle": "Dette filteret oppdateres automatisk av en liste",
    "priority": "Prioritet",
    "actions": "Handlinger",
    "noActionsDefined": "Ingen handlinger definert. Sett opp handlinger for å aktivere nedlasting.",
    "noActionsEnabled": "Du må aktivere minst én handling i filteret, ellers vil du ikke få noen nedlastinger.",
    "downloads": "Nedlastinger",
    "per": "per",
    "usesDisabledIndexers": "Bruker deaktiverte indekserere: {{names}}",
    "usesDeprecatedIndexers": "Bruker fjernede eller utgåtte indekserere: {{names}}. Rediger filteret for å fjerne dem, eller bruk Innstillinger → Indekserere.",
    "noIndexer": "INGEN INDEKSERER",
    "sort": {
      "label": "Sorter",
      "default": "Nyeste",
      "nameAsc": "Navn A-Å",
      "nameDesc": "Navn Å-A",
      "priorityDesc": "Prioritet Høy-Lav",
      "priorityAsc": "Prioritet Lav-Høy",
      "createdDesc": "Nylig opprettet først",
      "createdAsc": "Nylig opprettet sist",
      "updatedDesc": "Nylig oppdatert først",
      "updatedAsc": "Nylig oppdatert sist"
    },
    "indexerFilter": {
      "label": "Indekserer",
      "all": "Alle indeksere"
    }
  },
  "details": {
    "tabs": {
      "general": "Generelt",
      "moviesTv": "Filmer og serier",
      "music": "Musikk",
      "books": "Bøker",
      "advanced": "Avansert",
      "external": "Ekstern",
      "actions": "Handlinger",
      "notifications": "Varsler",
      "new": "NY"
    },
    "removeTitle": "Fjern filter: {{name}}",
    "removeText": "Er du sikker på at du vil fjerne dette filteret? Denne handlingen kan ikke angres.",
    "delete": "Slett filter",
    "reset": "Tilbakestill skjemakverdier",
    "resetSuccess": "Tilbakestilte alle filterverdier.",
    "save": "Lagre",
    "validationError": "Valideringsfeil",
    "validationErrors": "Valideringsfeil",
    "mustSelectClient": "Må velge klient"
  },
  "importer": {
    "title": "Importer filter (i JSON eller autodl-irssi-format)",
    "import": "Importer",
    "cancel": "Avbryt",
    "jsonImported": "Filter '{{name}}' ble importert!",
    "jsonImportFailed": "Klarte ikke å importere JSON-data. Informasjon loggført i konsollen.",
    "invalidFormat": "Kan ikke importere angitt filter -- det er verken i JSON eller autodl-irssi-format.",
    "autodlImportFailed": "Klarte ikke å importere autodl-irssi-filter '{{name}}'. Informasjon loggført i konsollen.",
    "autodlImportedOne": "Filter '{{name}}' ble importert!",
    "autodlImportedMany": "Alle {{count}} filtre ble importert!",
    "autodlImportedPartial": "{{success}}/{{total}} filtre ble importert. Se konsollen for detaljer.",
    "placeholder": "Lim inn filterdataene dine her (enten autobrr JSON-format eller hele autodl-irssi-konfigurasjonen din)",
    "warnings": "Advarsler ved import"
  },
  "general": {
    "filterName": "Filternavn",
    "filterNamePlaceholder": "f.eks. Filter 1",
    "announceTypes": "Annonseringstyper",
    "announceTypesTooltip": "NY! La samsvare med utgivelser som inneholder noen av de valgte annonseringstypene.",
    "indexers": "Indekserere",
    "deprecatedIndexer": "{{name}} (utgått)",
    "rulesTitle": "Regler",
    "rulesSubtitle": "Spesifiser regler for hvordan torrenter skal håndteres/velges.",
    "minSize": "Min. størrelse",
    "maxSize": "Maks størrelse",
    "sizePlaceholder": "f.eks. 100MiB, 80GB",
    "sizeTooltip": "Støtter enheter som MB, MiB, GB, osv.",
    "delay": "Forsinkelse",
    "delayPlaceholder": "Antall sekunder forsinkelse for handlinger",
    "delayTooltip": "Antall sekunder å vente før handlinger kjøres.",
    "priority": "Prioritet",
    "priorityPlaceholder": "Høyere tall = høyere prioritet",
    "priorityTooltip": "Filtre sjekkes i rekkefølge etter prioritet. Høyere tall = høyere prioritet.",
    "maxDownloads": "Maks nedlastinger",
    "maxDownloadsPlaceholder": "Tar ethvert tall (0 er uendelig)",
    "maxDownloadsTooltip": "Antall maksimale nedlastinger som spesifisert av den respektive enheten.",
    "maxDownloadsPer": "Maks nedlastinger per",
    "selectUnit": "Velg enhet",
    "maxDownloadsPerTooltip": "Tidsenheten for å telle maksimale nedlastinger per filter.",
    "maxDownloadsWindowType": "Vindutype",
    "selectWindowType": "Velg vindutype",
    "maxDownloadsWindowTypeTooltip": "Fast nullstiller telleren ved kalendergrenser (hel time, midnatt, ukestart). Rullerende teller et glidende vindu over de siste N enhetene.",
    "maxDownloadsPeriod": "Hver",
    "maxDownloadsPeriodTooltip": "Størrelsen på det rullerende vinduet i enheter. F.eks. tillater maks 150 nedlastinger med enhet DAY og hver 3 totalt 150 nedlastinger de siste 3 dagene.",
    "skipDuplicatesProfile": "Profil for duplikathopping",
    "selectProfile": "Velg profil",
    "skipDuplicatesProfileTooltip": "Velg profil for å hoppe over duplikater.",
    "enabled": "Aktivert",
    "enabledDescription": "Aktiver eller deaktiver dette filteret."
  },
  "actionsSection": {
    "title": "Handlinger",
    "subtitle": "Legg til nedlastingsklienter eller kjør egendefinerte kommandoer.",
    "addNew": "Legg til ny",
    "empty": "Ingen handlinger ennå!",
    "deleted": "Handling {{name}} ble slettet",
    "removeTitle": "Fjern filterhandling",
    "removeText": "Er du sikker på at du vil fjerne denne handlingen? Denne handlingen kan ikke angres.",
    "actionTitle": "Handling",
    "actionSubtitle": "Definer nedlastingsklienten for handlingen din og dens navn",
    "actionType": "Handlingstype",
    "selectType": "Velg type",
    "actionTypeTooltip": "Velg handlingstype for denne handlingen.",
    "name": "Navn",
    "removeAction": "Fjern handling",
    "close": "Lukk"
  },
  "notificationsSection": {
    "title": "Filtervarsler",
    "subtitle": "Konfigurer hvilke varsler som skal sendes for dette filteret. Disse overstyrer globale varslingsinnstillinger.",
    "addNotification": "Legg til varsel",
    "empty": "Ingen filterspesifikke varsler er konfigurert. Globale varsler vil bli brukt.",
    "selectNotification": "Velg varsel",
    "notificationDisabled": "Deaktivert for dette filteret",
    "serviceDisabled": "Tjenesten er deaktivert",
    "eventsCount_one": "{{count}} hendelse",
    "eventsCount_other": "{{count}} hendelser",
    "removeTitle": "Fjern varsel",
    "removeText": "Er du sikker på at du vil fjerne dette varselet? Denne handlingen kan ikke angres.",
    "notificationTitle": "Varsel",
    "notificationSubtitle": "Velg varslingstjenesten og hendelser som skal utløses",
    "notificationService": "Varslingstjeneste",
    "selectNotificationService": "Velg et varsel",
    "notificationServiceTooltip": "Velg varslingstjenesten som skal brukes for dette filteret.",
    "notificationSettings": "Varslingsinnstillinger",
    "disableNotification": "Deaktiver dette varselet",
    "disableNotificationDesc": "Ikke send hendelser gjennom denne varslingstjenesten for utgivelser som samsvarer med dette filteret.",
    "notificationDisabledInfo": "Denne varslingstjenesten er deaktivert for filteret. Filteret overstyrer fortsatt de globale varslingsinnstillingene.",
    "triggerEvents": "Utløs hendelser",
    "pushApproved": "Push godkjent",
    "pushRejected": "Push avvist",
    "pushError": "Push-feil",
    "pushApprovedDesc": "Send varsel når utgivelsen er vellykket sendt til klienten",
    "pushRejectedDesc": "Send varsel når utgivelsen blir avvist",
    "pushErrorDesc": "Send varsel når det oppstår en feil under behandling",
    "removeNotification": "Fjern varsel",
    "close": "Lukk"
  },
  "advanced": {
    "common": {
      "useRegex": "Bruk Regex",
      "regexTooltip1": "Dette feltet har full regex-støtte (Golang-variant).",
      "regexTooltip2": "Husk å krysse av for Bruk Regex hvis du bruker mer enn * og ?.",
      "regexTooltip3": "Modus: (?i) skiller ikke mellom store og små bokstaver"
    },
    "releases": {
      "title": "Utgivelsesnavn",
      "subtitle": "La kun visse utgivelsesnavn samsvare og/eller ignorer andre utgivelsesnavn.",
      "match": "Samsvar med utgivelser",
      "matchPlaceholder": "f.eks. *noe?film*,*noe?serie*s01*",
      "except": "Ekskluder utgivelser",
      "exceptPlaceholder": "f.eks. *dårlig?film*,*dårlig?serie*s03*",
      "alert": "Spør deg selv:",
      "matchWarning": "Har du en god grunn til å bruke Samsvar med utgivelser i stedet for en av de andre fanene?",
      "exceptWarning": "Har du en god grunn til å bruke Ekskluder utgivelser i stedet for en av de andre fanene?"
    },
    "groups": {
      "title": "Grupper",
      "subtitle": "La kun visse grupper samsvare og/eller ignorer andre grupper.",
      "match": "Samsvar med utgivelsesgrupper",
      "matchPlaceholder": "f.eks. gruppe1,gruppe2",
      "matchTooltip": "Kommaseparert liste over utgivelsesgrupper som skal samsvare.",
      "except": "Ekskluder utgivelsesgrupper",
      "exceptPlaceholder": "f.eks. dårliggruppe1,dårliggruppe2",
      "exceptTooltip": "Kommaseparert liste over utgivelsesgrupper som skal ignoreres (prioriteres foran Samsvar med utgivelser)."
    },
    "categories": {
      "title": "Kategorier",
      "subtitle": "La samsvare med eller ekskluder kategorier (hvis annonsert)",
      "match": "Samsvar med kategorier",
      "matchPlaceholder": "f.eks. *kategori*,kategori1",
      "matchTooltip": "Kommaseparert liste over kategorier som skal samsvare.",
      "except": "Ekskluder kategorier",
      "exceptPlaceholder": "f.eks. *kategori*",
      "exceptTooltip": "Kommaseparert liste over kategorier som skal ignoreres (prioriteres foran Samsvar med kategorier)."
    },
    "tags": {
      "title": "Tagger",
      "subtitle": "La samsvare med eller ekskluder tagger (hvis annonsert)",
      "match": "Samsvar med tagger",
      "matchPlaceholder": "f.eks. tag1,tag2",
      "matchTooltip": "Kommaseparert liste over tagger som skal samsvare.",
      "matchLogic": "Samsvarslogikk",
      "matchLogicDefault": "hvilken som helst",
      "matchLogicTooltip": "Logikk brukt for å samsvare filtertagger.",
      "except": "Ekskluder tagger",
      "exceptPlaceholder": "f.eks. tag1,tag2",
      "exceptTooltip": "Kommaseparert liste over tagger som skal ignoreres (prioriteres foran Samsvar med tagger).",
      "exceptLogic": "Ekskluderingslogikk",
      "exceptLogicDefault": "hvilken som helst",
      "exceptLogicTooltip": "Logikk brukt for å samsvare med ekskluderte tagger."
    },
    "uploaders": {
      "title": "Opplastere",
      "subtitle": "La samsvare med eller ignorer opplastere (hvis annonsert)",
      "match": "Samsvar med opplastere",
      "matchPlaceholder": "f.eks. opplaster1,opplaster2",
      "matchTooltip": "Kommaseparert liste over opplastere som skal samsvare.",
      "except": "Ekskluder opplastere",
      "exceptPlaceholder": "f.eks. anonym1,anonym2",
      "exceptTooltip": "Kommaseparert liste over opplastere som skal ignoreres (prioriteres foran Samsvar med opplastere)."
    },
    "language": {
      "title": "Språk",
      "subtitle": "La samsvare med eller ignorer språk (hvis annonsert)",
      "match": "Samsvar med språk",
      "except": "Ekskluder språk"
    },
    "origins": {
      "title": "Opprinnelser",
      "subtitle": "La samsvare med Internals, Scene, P2P, osv. (hvis annonsert)",
      "match": "Samsvar med opprinnelser",
      "except": "Ekskluder opprinnelser"
    },
    "freeleech": {
      "title": "Freeleech",
      "subtitle": "La samsvare basert på freeleech (hvis annonsert)",
      "percent": "Freeleech-prosent",
      "percentPlaceholder": "f.eks. 50,75-100",
      "percentTooltip1": "Freeleech kan annonseres som en binær sann/usann verdi eller som en prosentandel, avhengig av indeksereren. Bruk den ene eller den andre.",
      "percentTooltip2": "Freeleech-bryteren overstyrer dette feltet hvis den er slått på/sann.",
      "percentTooltip3": "Se vår dokumentasjon for flere detaljer:",
      "toggle": "Freeleech",
      "toggleDescription": "Kan ikke brukes sammen med Freeleech-prosent. Overstyrer Freeleech-prosent hvis slått på/sann.",
      "toggleTooltip1": "Freeleech kan annonseres som en binær sann/usann verdi eller som en prosentandel, avhengig av indeksereren. Bruk den ene eller den andre.",
      "toggleTooltip2": "Dette feltet overstyrer Freeleech-prosent hvis den er slått på/sann.",
      "toggleTooltip3": "Se hvem som bruker hva i dokumentasjonen:"
    },
    "feedSpecific": {
      "title": "RSS/Torznab/Newznab-spesifikt",
      "subtitle": "Disse alternativene er kun for feeds som RSS, Torznab og Newznab",
      "matchDescription": "Samsvar med beskrivelse",
      "matchDescriptionPlaceholder": "f.eks. *noe?film*,*noe?serie*s01*",
      "exceptDescription": "Ekskluder beskrivelse",
      "exceptDescriptionPlaceholder": "f.eks. *dårlig?film*,*dårlig?serie*s03*",
      "minSeeders": "Min. seeders",
      "maxSeeders": "Maks seeders",
      "minLeechers": "Min. leechers",
      "maxLeechers": "Maks leechers",
      "countPlaceholder": "Tar ethvert tall (0 er uendelig)",
      "seedersTooltip": "Antall {{type}} som spesifisert av den respektive enheten. Kun for Torznab"
    },
    "rawReleaseTags": {
      "title": "Rå utgivelsestagger (Raw Release Tags)",
      "subtitlePrefix": "Kun for avanserte brukere",
      "subtitleSuffix": "Dette er den rå releaseTags-strengen fra annonseringen.",
      "warning": "Disse er kanskje ikke det du tror de er. For svært avanserte brukere som vet hvordan ting analyseres.",
      "match": "Samsvar med utgivelsestagger",
      "except": "Ekskluder utgivelsestagger",
      "placeholder": "f.eks. *mkv*,*foreign*"
    }
  },
  "moviesTv": {
    "title": "Filmer / Serier",
    "placeholder": "f.eks. Film,Serie 1,Serie?2",
    "wildcardTooltip": "Du kan bruke grunnleggende filtrering som jokertegn * eller erstatte enkelttegn med ?",
    "years": "År",
    "yearsPlaceholder": "f.eks. 2018,2019-2021",
    "yearsTooltip": "Dette feltet tar et område av år og/eller kommaseparerte enkeltår.",
    "seasonEpisode": {
      "title": "Sesonger, episoder og dato",
      "subtitle": "Sett samsvarsbegrensninger for sesong, episode, år, måneder og dag.",
      "seasons": "Sesonger",
      "seasonsPlaceholder": "f.eks. 1,3,2-6",
      "seasonsTooltip": "Se dokumentasjonen for informasjon om hvordan du kun laster ned sesongpakker:",
      "episodes": "Episoder",
      "episodesPlaceholder": "f.eks. 2,4,10-20",
      "episodesTooltip": "Se dokumentasjonen for informasjon om hvordan du kun laster ned episoder:",
      "dailyShows": "Daglige serier (Daily Shows)",
      "months": "Måneder",
      "monthsPlaceholder": "f.eks. 4,2-9",
      "monthsTooltip": "Dette feltet tar et område av måneder og/eller kommaseparerte enkeltmåneder.",
      "days": "Dager",
      "daysPlaceholder": "f.eks. 1,15-30",
      "daysTooltip": "Dette feltet tar et område av dager og/eller kommaseparerte enkeltdager.",
      "smartEpisode": "Smart episode",
      "smartEpisodeDescription": "Ikke la samsvare med episoder som er eldre enn den siste som samsvarte."
    },
    "quality": {
      "title": "Kvalitet",
      "subtitle": "Sett samsvarsbegrensninger for oppløsning, kilde, kodek og lignende.",
      "resolutions": "Oppløsninger",
      "resolutionsTooltip": "Vil samsvare med utgivelser som inneholder noen av de valgte oppløsningene.",
      "sources": "Kilder",
      "sourcesTooltip": "Vil samsvare med utgivelser som inneholder noen av de valgte kildene.",
      "codecs": "Kodeker",
      "codecsTooltip": "Vil samsvare med utgivelser som inneholder noen av de valgte kodekene.",
      "containers": "Konteinere",
      "containersTooltip": "Vil samsvare med utgivelser som inneholder noen av de valgte konteinerne.",
      "matchHdr": "Samsvar med HDR",
      "matchHdrTooltip": "Vil samsvare med utgivelser som inneholder noen av de valgte HDR-betegnelsene.",
      "exceptHdr": "Ekskluder HDR",
      "exceptHdrTooltip": "Vil ikke samsvare med utgivelser som inneholder noen av de valgte HDR-betegnelsene (prioriteres foran Samsvar med HDR).",
      "matchOther": "Samsvar med annet",
      "matchOtherTooltip": "Vil samsvare med utgivelser som inneholder noen av de valgte betegnelsene.",
      "exceptOther": "Ekskluder annet",
      "exceptOtherTooltip": "Vil ikke samsvare med utgivelser som inneholder noen av de valgte andre betegnelsene (prioriteres foran Samsvar med annet)."
    }
  },
  "music": {
    "artists": "Artister",
    "artistsPlaceholder": "f.eks. Artist En",
    "albums": "Albumer",
    "albumsPlaceholder": "f.eks. Det Albumet",
    "wildcardTooltip": "Du kan bruke grunnleggende filtrering som jokertegn * eller erstatte enkelttegn med ?",
    "matchRecordLabels": "Samsvar med plateselskaper",
    "matchRecordLabelsPlaceholder": "f.eks. Anjunabeats, Armada",
    "matchRecordLabelsTooltip": "Kommaseparert liste over plateselskaper som skal samsvare. Kun Orpheus og Redacted støtter dette.",
    "exceptRecordLabels": "Ekskluder plateselskaper",
    "exceptRecordLabelsPlaceholder": "f.eks. Anjunadeep, Armind",
    "exceptRecordLabelsTooltip": "Kommaseparert liste over plateselskaper som skal ignoreres (prioriteres foran Samsvar med annet plateselskaper). Kun Orpheus og Redacted støtter dette.",
    "releaseDetails": {
      "title": "Utgivelsesdetaljer",
      "subtitle": "Type (Album, Singel, EP, osv.) og utgivelsesår (hvis annonsert)",
      "musicType": "Musikktype",
      "musicTypeTooltip": "Vil kun samsvare med utgivelser med noen av de valgte typene.",
      "years": "År",
      "yearsPlaceholder": "f.eks. 2018,2019-2021",
      "yearsTooltip": "Dette feltet tar et område av år og/eller kommaseparerte enkeltår."
    },
    "quality": {
      "title": "Kvalitet",
      "subtitle": "Format, kilde, logg, osv.",
      "format": "Format",
      "formatTooltip": "Vil kun samsvare med utgivelser med noen av de valgte formatene. Dette overstyres av Perfekt FLAC.",
      "quality": "Kvalitet",
      "qualityTooltip": "Vil kun samsvare med utgivelser med noen av de valgte kvalitetene. Dette overstyres av Perfekt FLAC.",
      "media": "Medium",
      "mediaTooltip": "Vil kun samsvare med utgivelser med noen av de valgte kildene. Dette overstyres av Perfekt FLAC.",
      "cue": "CUE",
      "cueDescription": "Må inkludere CUE-info",
      "log": "LOG",
      "logDescription": "Må inkludere LOG-info",
      "logScore": "Logg-poengsum (Log score)",
      "logScorePlaceholder": "f.eks. 100",
      "logScoreTooltip": "Logg-poengsum går fra 0 til 100. Dette overstyres av Perfekt FLAC.",
      "or": "ELLER",
      "perfectFlac": "Perfekt FLAC",
      "perfectFlacDescription": "Overstyr alle alternativer om kvalitet, kilde, format og cue/log/logg-poengsum.",
      "perfectFlacTooltip": "Overstyr alle alternativer om kvalitet, kilde, format og CUE/LOG/LOG-poengsum.",
      "perfectFlacHint": "Dette er hva du vil ha i 90 % av tilfellene (i stedet for alternativene ovenfor)."
    }
  },
  "books": {
    "authors": "Forfattere",
    "authorsPlaceholder": "f.eks. Forfatter En",
    "titles": "Titler",
    "titlesPlaceholder": "f.eks. Den Boken",
    "wildcardTooltip": "Du kan bruke grunnleggende filtrering som jokertegn * eller erstatte enkelttegn med ?",
    "years": "År",
    "yearsPlaceholder": "f.eks. 2018,2019-2021",
    "yearsTooltip": "Dette feltet tar et område av år og/eller kommaseparerte enkeltår.",
    "options": {
      "title": "Alternativer",
      "subtitle": "Språk, format og tagger",
      "matchLanguage": "Samsvar med språk",
      "exceptLanguage": "Ekskluder språk",
      "format": "Format",
      "formatTooltip": "Vil kun samsvare med utgivelser med noen av de valgte formatene.",
      "matchTags": "Samsvar med tagger",
      "matchTagsPlaceholder": "f.eks. tag1,tag2",
      "matchTagsTooltip": "Kommaseparert liste over tagger som skal samsvare.",
      "exceptTags": "Ekskluder tagger",
      "exceptTagsPlaceholder": "f.eks. tag1,tag2",
      "exceptTagsTooltip": "Kommaseparert liste over tagger som skal ignoreres (prioriteres foran Samsvar med tagger)."
    }
  },
  "external": {
    "title": "Eksterne filtre",
    "subtitle": "Kjør eksterne skript eller webhooks og sjekk status som en del av filtreringen.",
    "addNew": "Legg til ny",
    "empty": "Ingen eksterne filtre ennå!",
    "removeTitle": "Fjern eksternt filter",
    "removeText": "Er du sikker på at du vil fjerne dette eksterne filteret? Denne handlingen kan ikke angres.",
    "sectionTitle": "Eksternt filter",
    "sectionSubtitle": "Definer typen på filteret ditt og dets navn",
    "type": "Type",
    "name": "Navn",
    "onError": "Ved feil (On Error)",
    "selectType": "Velg type",
    "typeTooltip": "Velg type for dette eksterne filteret.",
    "onErrorTooltip": "Velg hva som skal gjøres ved feil for dette eksterne filteret.",
    "remove": "Fjern ekstern",
    "close": "Lukk",
    "types": {
      "EXEC": "Exec",
      "WEBHOOK": "Webhook"
    },
    "onErrorOptions": {
      "REJECT": "Avvis",
      "CONTINUE": "Fortsett til neste"
    },
    "execute": {
      "title": "Kjør (Execute)",
      "subtitle": "Spesifiser den kjørbare filen, argumentet og forventet avslutningsstatus for å kjøre som et forhåndsfilter",
      "path": "Sti til kjørbar fil",
      "pathPlaceholder": "Absolutt sti til kjørbar fil f.eks. /bin/test",
      "pathTooltip": "For egendefinerte kommandoer bør du spesifisere den fulle stien til binærfilen/programmet du vil kjøre. Og du kan inkludere dine egne statiske variabler:",
      "args": "Exec-argumenter",
      "argsPlaceholder": "Argumenter f.eks. --test \"{{ .TorrentName }}\"",
      "expectedExitStatus": "Forventet avslutningsstatus"
    },
    "request": {
      "title": "Forespørsel (Request)",
      "subtitle": "Spesifiser din forespørselsdestinasjon (endpoint), headere og forventet returstatus",
      "endpoint": "Endepunkt (Endpoint)",
      "endpointPlaceholder": "Vert f.eks. http://localhost/webhook",
      "endpointTooltip": "URL eller IP til din API. Send med parametere og sett API-tokens osv.",
      "httpMethod": "HTTP-metode",
      "httpMethodDefault": "Velg HTTP-metode",
      "httpMethodTooltip": "Velg HTTP-metoden for denne webhooken. Standard er POST",
      "headers": "HTTP-forespørselsheadere",
      "headersPlaceholder": "HEADER=custom1,HEADER2=custom2",
      "expectedStatus": "Forventet HTTP-statuskode"
    },
    "retry": {
      "title": "Prøv på nytt (Retry)",
      "subtitle": "Adferd for å prøve på nytt ved forespørselsfeil",
      "retryStatus": "Prøv på nytt ved HTTP-statuskode(r)",
      "retryStatusPlaceholder": "Prøv på nytt ved status f.eks. 202, 204",
      "retryAttempts": "Maksimum antall forsøk",
      "retryDelaySeconds": "Forsinkelse i sekunder før nytt forsøk"
    },
    "payload": {
      "title": "Nyttelast (Payload)",
      "subtitle": "Spesifiser din JSON-payload",
      "data": "Data (json)",
      "dataPlaceholder": "Forespørselsdata: { \"key\": \"value\" }"
    }
  },
  "actionComponents": {
    "instance": {
      "title": "Instans",
      "subtitle": "Velg den spesifikke instansen som du vil at skal håndtere dette utgivelsesfilteret."
    },
    "common": {
      "category": "Kategori",
      "categoryPlaceholder": "f.eks. kategori",
      "categoryTooltip": "Kategorien må eksistere allerede.",
      "savePath": "Lagringssti",
      "savePathPlaceholder": "f.eks. /full/sti/til/nedlastingsmappe",
      "numberNoLimit": "Tar ethvert tall (0 er ingen grense)",
      "limitsTitle": "Grenser",
      "limitsSubtitle": "Konfigurer grensene for hastighet/ratio/seed-tid",
      "limitDownloadKib": "Begrens nedlastingshastighet (KiB/s)",
      "limitUploadKib": "Begrens opplastingshastighet (KiB/s)",
      "limitDownloadKb": "Begrens nedlastingshastighet (KB/s)",
      "limitUploadKb": "Begrens opplastingshastighet (KB/s)",
      "ratioLimit": "Ratiogrense",
      "seedTimeMinutes": "Seed-tidsgrense (minutter)",
      "addPaused": "Legg til satt på pause",
      "addPausedDescription": "Legg til torrent satt på pause",
      "skipHashCheck": "Hopp over hash-sjekk",
      "skipHashCheckDescription": "Legg til torrent og hopp over hash-sjekk",
      "announceTitle": "Annonser",
      "announceSubtitle": "Sett antall gjenannonsering (hvis nødvendig), slett etter Y annonseringsfeil, osv.",
      "disableReannounce": "Deaktiver gjenannonsering",
      "disableReannounceDescription": "Gjenannonsering er aktivert som standard. Deaktiver hvis det ikke er nødvendig",
      "reannounceInterval": "Gjenannonseringintervall. Kjør hver X sekunder",
      "reannounceIntervalPlaceholder": "7 er standard og anbefalt",
      "deleteStalled": "Slett fastlåste",
      "deleteStalledDescription": "Slett fastlåste torrenter etter Y forsøk",
      "reannounceMaxAttempts": "Kjør gjenannonsering Y ganger"
    },
    "test": {
      "alert": "Obs!",
      "text": "Testhandlingen gjør ingenting annet enn å vise om filteret fungerer. Sørg for å ha Logger-siden åpen mens du tester."
    },
    "exec": {
      "title": "Exec-argumenter",
      "subtitle": "Spesifiser den kjørbare filen og dens argumenter som skal kjøres ved filtersamsvar. Bruk en absolutt sti.",
      "path": "Sti til kjørbar fil",
      "pathPlaceholder": "Sti til program f.eks. /bin/test",
      "arguments": "Argumenter",
      "argumentsPlaceholder": "Argumenter f.eks. --test"
    },
    "watchFolder": {
      "title": "Overvåket mappe-argumenter (Watch Folder)",
      "subtitle": "Pek på hvor autobrr skal lagre filene den henter. Bruk en absolutt sti.",
      "directory": "Overvåket katalog",
      "directoryPlaceholder": "Overvåket katalog f.eks. /home/bruker/rmappe"
    },
    "webhook": {
      "title": "Webhook-argumenter",
      "subtitle": "Spesifiser payloaden som skal sendes til ønsket endepunkt ved filtersamsvar.",
      "endpoint": "Endepunkt",
      "endpointPlaceholder": "Vert f.eks. http://localhost/webhook",
      "endpointTooltip": "URL eller IP til API-et ditt. Send med parametere og sett API-tokens osv.",
      "payload": "Nyttelast (json)",
      "payloadPlaceholder": "Forespørselsdata: { \"key\": \"value\" }"
    },
    "arr": {
      "overrideClientName": "Overstyr nedlastingsklientens navn for arr",
      "overrideClientNameTooltip": "Overstyr nedlastingsklientens navn fra det som er satt i Klienter. Nyttig hvis du har flere klienter inne i arr.",
      "overrideClientId": "Overstyr nedlastingsklientens ID for arr AVLEGS (DEPRECATED)",
      "overrideClientIdTooltip": "Overstyr nedlastingsklientens ID fra det som er satt i Klienter. Nyttig hvis du har flere klienter inne i arr."
    },
    "qbittorrent": {
      "macrosTooltip": "Feltet kan bruke makroer for å transformere/legge til verdier fra metadata:",
      "tags": "Tagger",
      "tagsPlaceholder": "f.eks. tag1,tag2",
      "savePathPlaceholder": "f.eks. /full/sti/til/lagringsmappe",
      "savePathTooltip": "Sett en egendefinert lagringssti for denne handlingen. Automatisk torrenthåndtering vil ta seg av dette hvis du bruker qBittorrent med kategorier.",
      "downloadPath": "Nedlastingssti",
      "downloadPathPlaceholder": "f.eks. /full/sti/til/nedlastingsmappe",
      "downloadPathTooltip": "Sett en egendefinert (uferdig) nedlastingssti for denne handlingen. Automatisk torrenthåndtering vil ta seg av dette hvis du bruker qBittorrent med kategorier.",
      "rulesTitle": "Regler",
      "rulesSubtitle": "Konfigurer reglene for torrentklienten din",
      "ignoreRules": "Ignorer eksisterende klientregler",
      "ignoreRulesDescription": "Velg å ignorere regler satt i Klientinnstillinger.",
      "contentLayout": "Innholdslayout",
      "contentLayoutDefault": "Velg innholdslayout",
      "priority": "Prioritet",
      "priorityDefault": "Deaktivert",
      "priorityTooltip": "Torrent-kø vil bli aktivert for deg hvis den er deaktivert. Sørg for at du setter dine foretrukne grenser for det i klienten din.",
      "firstLastPiece": "Last ned første og siste biter først",
      "firstLastPieceDescription": "Legg til torrent og last ned første og siste biter først"
    },
    "deluge": {
      "label": "Etikett",
      "labelPlaceholder": "f.eks. etikett1 (må eksistere i Deluge for å fungere)",
      "skipHashCheckTooltip": "Dette vil kun fungere på Deluge v2."
    },
    "transmission": {
      "label": "Torrentetiketter",
      "labelPlaceholder": "f.eks. etikett1,etikett2"
    },
    "rtorrent": {
      "label": "Etikett",
      "labelPlaceholder": "f.eks. etikett1,etikett2",
      "renameToPath": "Ikke legg til torrentnavn i stien",
      "renameDefault": "Nei"
    },
    "porla": {
      "preset": "Forhåndsinnstilling",
      "presetPlaceholder": "f.eks. standard",
      "presetTooltip": "Et skiller-mellom-store-og-små-bokstaver (case-sensitive) navn på forhåndsinnstilling som konfigurert i Porla.",
      "savePathPlaceholder": "f.eks. /full/sti/til/torrent/data"
    }
  },
  "addForm": {
    "title": "Opprett filter",
    "subtitle": "Legg til nytt filter.",
    "closePanel": "Lukk panel",
    "name": "Navn",
    "required": "Påkrevd",
    "cancel": "Avbryt",
    "create": "Opprett",
    "added": "Filter {{name}} ble lagt til"
  }
}
